import { SWIMLANES_TO_SHOW } from './constants';

export const getSwimlaneConfig = (slug: string) =>
  SWIMLANES_TO_SHOW.find((swimlane) => swimlane.urlSlug === slug);
